export const LABEL_TEXT_DARK_GREY = "#454954";
export const PLACEHOLDER_INPUT_GREY = "#b8c0cc";
export const LABEL_TEXT_LIGHTER_GREY = "#8993a9";
export const INFO_DARK_GREY = "#656d78";
export const BACKGROUND_LIGHT_GREY = "#e6e9ee";
export const BACKGROUND_LIGHT_ORANGE = "#e4701e";
export const UNDERLINE_ORANGE = "#fd8f40";
export const INPUT_READONLY = "#737475"
export const PILL_READONLY = "#b1b2b5"

export const SHADOWIE_GREY = "#c7ccdb";
export const SHADOWIE_HOVER_GREY = "#ccd1de";
export const LIGHT_GREY_OPTIONS = "#f1f2f6";
export const SOFT_GREY = "#cad3e0";
export const RUBBER_GUM = "#656D78";

export const COLOR_PALETTE = {
    // whites
    SNOWFLAKE: "#FFFFFF",
    OVERCAST: "#FAFAFB",
    UNDERCAST: "#F7F7F7",
    // light greys
    GRANDMA: "#F1F2F6",
    MY_UBER: "#E6E9EE",
    GHOST: "#CAD3E0",
    GHOST_WHITE: '#f8f8fd',
    LIGHT_GREY_1: "#e0e6ed",
    LIGHT_GREY_2: "#a5a5a5",
    CHASSIS_LIGHT_GRAY: '#7283ad',
    CHASSIS_LIGHT_GRAY_2: '#B1B2B5',
    CHASSIS_LIGHT_GRAY_3: '#e6e7eb',
    CHASSIS_LIGHT_GRAY_4: 'rgba(250, 250, 251, 0.11)',
    CHASSIS_LIGHT_GRAY_5: '#9b9da1',
    CHASSIS_LIGHT_GRAY_6: '#6f82b1',
    // mediumish grey
    SHADOW: "#C7CCDB",
    DIRTY: "#8993a9",
    MERM: "#B8C0CC",
    HOEDOWN: "#868F9D",
    GRANDMAS_SILVER_COTTON_CANDY: "#979797",
    EARL: "#898a8c",
    // dark greys
    RUBBER_GUM: '#656D78',
    STEAK_CHAR: '#454954',
    SLATE: '#373F52',
    SLATE_LIGHT: '#434D62',
    ALMOST_BLACK: '#1b1b1e',
    DARK_GREY_1: '#58636c',
    DARK_GREY_2: '#0070c9',
    DARK_GREY_3: '#363f55',
    DARK_GREY_4: '#343f57',
    DARK_GREY_5: '#596269',
    CHASSIS_GRAY: '#373f53',
    CHASSIS_MEDIUM_GRAY: '#616e89',
    CHASSIS_DARK_GRAY: '#f6f6f6',
    // oranges
    AVB: "#E4701E",
    CHASSIS_ORANGE: '#f47b38',
    MANDARIN: "#FD8F40",
    LIGHTNING_YELLOW: "#f5a623",
    OUTRAGEOUS_ORANGE: '#fd583e',
    // green for success!
    PETER_PAN: "#48CFAE",
    // reds
    VAMP: "#D65556",
    WILD_FIRE: "#FF3F3F",
    ALERT_RED: "#d65556",
    ERROR_RED: "#ec4205",
    LIGHT_RED: "#FFBFBA",
    BRIGHT_RED: "#FF4133",
    ERROR_RED_2: "#FF2A00",
    // blues
    BONDI_BLUE: '#079aa5',
    CHASSIS_LIGHT_BLUE_GRAY: "#b7c0d5",
    VAN_GOGH: "#58AAE8",
    ROYAL: "#2E9BED",
    BLUE_DARK_1: "#0070c9",
    FOCUS_BLUE: "#4666e7",
    COOL_BLUE: "#1950c0",
    DARK_BLUE: "#112240",
    // purples
    ZOMBIE_EYE: "#BDC7EF",
    CHASSIS_LIGHT_PURPLE: 'rgba(70, 102, 231, 0.13)',
    // card selected border
    VAMP_LIGHT: "rgba(214, 85, 86, 0.75)",
    // transparent
    VODKA: "transparent",
};
